export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";


export const ADD_PRODUCT_REQUEST = "ADD_PRODUCT_REQUEST";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAILURE = "ADD_PRODUCT_FAILURE";


export const GET_NEWARRIVAL_REQUEST = "GET_NEWARRIVAL_REQUEST";
export const GET_NEWARRIVAL_SUCCESS = "GET_NEWARRIVAL_SUCCESS";
export const GET_NEWARRIVAL_FAILURE = "GET_NEWARRIVAL_FAILURE";

export const DELETE_NEWARRIVAL_REQUEST = "DELETE_NEWARRIVAL_REQUEST";
export const DELETE_NEWARRIVAL_SUCCESS = "DELETE_NEWARRIVAL_SUCCESS";
export const DELETE_NEWARRIVAL_FAILURE = "DELETE_NEWARRIVAL_FAILURE";

export const EDIT_NEWARRIVAL_REQUEST = "EDIT_NEWARRIVAL_REQUEST";
export const EDIT_NEWARRIVAL_SUCCESS = "EDIT_NEWARRIVAL_SUCCESS";
export const EDIT_NEWARRIVAL_FAILURE = "EDIT_NEWARRIVAL_FAILURE";

export const UPDATE_NEWARRIVAL_REQUEST = "UPDATE_NEWARRIVAL_REQUEST";
export const UPDATE_NEWARRIVAL_SUCCESS = "UPDATE_NEWARRIVAL_SUCCESS";
export const UPDATE_NEWARRIVAL_FAILURE = "UPDATE_NEWARRIVAL_FAILURE";

export const SET_NEWARRIVAL_UPDATED = "SET_NEWARRIVAL_UPDATED";


export const ADD_CART_REQUEST = "ADD_CART_REQUEST";
export const ADD_CART_SUCCESS = "ADD_CART_SUCCESS";
export const ADD_CART_FAILURE = "ADD_CART_FAILURE";

export const REMOVE_CART_ITEM="REMOVE_CART_ITEM";
export const SAVE_SHIPPING_INFO="SAVE_SHIPPING_INFO"